module.exports = __webpack_public_path__ + "img/swagger.09f0436c.svg";